import { buildHeaders } from "./apiConfig";
import { GENERATE_SRT_API_URL } from "../constants";

export async function generateSrtFiles(jobId) {
  if (!jobId) {
    throw new Error("[generateSrtService] jobId is required.");
  }

  const url = GENERATE_SRT_API_URL.replace(/\/$/, "");
  const payload = JSON.stringify({ job_id: jobId });

  // eslint-disable-next-line no-console
  console.log(`[generateSrtService] POST ${url}`, { job_id: jobId });

  let response;
  try {
    response = await fetch(url, {
      method: "POST",
      headers: buildHeaders(),
      body: payload,
    });
  } catch (networkErr) {
    throw new Error("Network error while triggering SRT generation. Please check your connection.");
  }

  let json = {};
  try {
    json = await response.json();
  } catch {
    /* non-JSON body — fall through */
  }

  if (!response.ok) {
    const detail = json.error || json.message || `HTTP ${response.status}`;
    // eslint-disable-next-line no-console
    console.error(`[generateSrtService] ❌ ${response.status} — ${detail}`);
    throw new Error(detail);
  }

  // eslint-disable-next-line no-console
  console.log("[generateSrtService] ✅ SRT generation triggered successfully.", json);
  return json;
}
